var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "footer",
    { staticClass: "footer" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("Base"),
      _vm._v(" "),
      _c("BulderDialog"),
      _vm._v(" "),
      _c("FilterSaver"),
      _vm._v(" "),
      _c("ConfirmDelete"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "footer-scroll-top" }, [
        _c("div", { staticClass: "footer-scroll-top__btn" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer-top" }, [
        _c("div", { staticClass: "footer__share" }, [
          _c(
            "a",
            {
              attrs: {
                href: "https://twitter.com/paycompliance",
                target: "_blank",
              },
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/icons/i_twitter.svg"),
                  alt: "twitter",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.linkedin.com/company/paymentscompliance/",
                target: "_blank",
              },
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/icons/i_linkedin.svg"),
                  alt: "linkedin",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.youtube.com/@vixioregulatoryintelligence",
                target: "_blank",
              },
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/icons/i_youtube_corpFill.svg"),
                  alt: "youtube",
                },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "footer__contacts" }, [
          _c("div", [
            _c("div", [
              _c("p", { staticClass: "strong" }, [_vm._v("United Kingdom")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n              St Clare House, 30 Minories\n              "
                ),
                _c("br"),
                _vm._v("\n              London, EC3N 1DD\n            "),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "strong",
                  attrs: { href: "tel:+44(0)2079219980" },
                },
                [_vm._v("+44(0)207 921 9980")]
              ),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("p", { staticClass: "strong" }, [
                _vm._v("United States Of America"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n              1250 Connecticut Avenue, NW Suite 700"),
                _c("br"),
                _vm._v("\n              Washington D.C., 200036\n            "),
              ]),
              _vm._v(" "),
              _c(
                "a",
                { staticClass: "strong", attrs: { href: "tel:+12022613567" } },
                [_vm._v("+1 202 261 3567")]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer__links" }, [
        _c("div", { staticClass: "footer__links-top" }, [
          _c(
            "a",
            {
              attrs: {
                href: "https://vixio.com/contact-us/",
                target: "_blank",
              },
            },
            [_vm._v(" Feedback ")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://vixio.com/contact-us/",
                target: "_blank",
              },
            },
            [_vm._v("\n          Contact us\n        ")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "footer__links-bottom" }, [
          _c(
            "a",
            { attrs: { href: "https://www.vixio.com/terms-and-conditions" } },
            [_vm._v("\n          Terms and Conditions\n        ")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://vixio.com/anti-slavery-policy/",
                target: "_blank",
              },
            },
            [_vm._v("\n          Anti-Slavery Policy\n        ")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer-bottom" }, [
        _c("p", { staticClass: "copy" }, [
          _vm._v(
            "\n        All rights reserved. ©Compliance Online Limited (trading as VIXIO).\n        St. Clare House, 30 Minories, London, EC3N 1DD.\n      "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }